import { SearchCompaniesQueryParams } from '../../../components/pages/connected/Dashboard/DashboardCompanies/DashboardCompaniesTable/DashboardCompaniesTable.types';
import { ProfileCompanyFormSchema } from '../../../components/pages/connected/Profile/ProfileCompany/ProfileCompanyForm/ProfileCompanyForm.types';
import { AllCompaniesQueryParams } from '../../../hooks/fetchers/useAllCompanies/useAllCompanies.types';
import { SignUpENTRequestData } from '../../../types/api/endpoints/auth/register.types';
import {
  StaticGetEndpoints,
  StaticPostEndpoints,
} from '../../../types/api/endpoints/staticEndpoints';
import { api } from '../api';

export const COMPANY_ENDPOINTS = Object.freeze({
  signUp: (data: SignUpENTRequestData) => api.post(StaticPostEndpoints.SignUpENT, data),

  current: () => api.get(StaticGetEndpoints.CurrentCompany),
  currentNAF: () => api.get(StaticGetEndpoints.CurrentCompanyNAF),

  getAll: (params: AllCompaniesQueryParams) => api.get(StaticGetEndpoints.AllCompanies, params),
  getConfirmed: (params: AllCompaniesQueryParams) =>
    api.get(StaticGetEndpoints.AllCompaniesConfirmed, params),
    
  getFull: (userId: number) => api.get(`/company/full/user/${userId}`),

  search: (search: string, params: SearchCompaniesQueryParams) =>
    api.get(`/company/search/${search}`, {
      ...params,
      domains: params.domains || undefined,
      fieldsOfActivity: params.fieldsOfActivity || undefined,
    }),
  searchConfirmed: (search: string, params: SearchCompaniesQueryParams) =>
    api.get(`/company/search_confirmed/${search}`, {
      ...params,
      domains: params.domains || undefined,
      fieldsOfActivity: params.fieldsOfActivity || undefined,
    }),
    
  updateNAF: (fieldsOfActivity: string[]) =>
    api.post(StaticPostEndpoints.UpdateCompanyNAF, { fieldsOfActivity }),

  // Pending
  createPending: (data: ProfileCompanyFormSchema) =>
    api.post(StaticPostEndpoints.CreatePendingCompany, data),

  currentPending: () => api.get(StaticGetEndpoints.CurrentPendingCompany),
});
